module.exports = __webpack_public_path__ + "assets/img/s1_tab2_m.65455aba.png";